import { Link } from '@auspost/postmaster-react';

import Infotip from 'App/common/Tooltip/Infotip/infotip';
import CrossIcon from 'assets/cross.svg';
import SafeDropIcon from 'assets/safeDrop.svg';
import { SafeDropInstruction } from 'models/DeliveryPreference';
import { AtlStatusValue } from 'models/shipments';
import { getAtlLink } from 'utils/window.utils';

import { SAFE_DROP_INSTRUCTIONS_TEST_ID } from '../../DetailsPanel.test-ids';

import styles from '../DeliveryInstructions.module.scss';

const recipientLine = (
  trackingNumber: string,
  atlEligible?: boolean,
  atlStatusValue?: AtlStatusValue | null,
  safeDropIneligibilityCode?: string | null,
  deliveryInstruction?: SafeDropInstruction | null
) => {
  // * reciepient line only shows safedrop link to KNOWN/AUTH user
  // * AtlStatusValue is null in ANON - hence no LIIASP flow required
  const atlLink = getAtlLink(trackingNumber);

  if (atlEligible) {
    if (atlStatusValue === AtlStatusValue.REQUESTED)
      return (
        <>
          <SafeDropIcon className={styles.icon} />
          Recipient authorised Safe Drop
        </>
      );

    if (atlStatusValue === AtlStatusValue.ELIGIBLE || atlStatusValue === AtlStatusValue.CANCELLED) {
      return (
        <>
          <SafeDropIcon className={styles.icon} />
          <Link data-testid={SAFE_DROP_INSTRUCTIONS_TEST_ID} href={atlLink}>
            Recipient can authorise Safe Drop
          </Link>
        </>
      );
    }
  } else {
    if (deliveryInstruction !== SafeDropInstruction.ON || !safeDropIneligibilityCode) return null;
    const safeDropCantBeAppliedCodes = ['2', '5', '6', '7', 'X', 'Y'];
    if (safeDropCantBeAppliedCodes.includes(safeDropIneligibilityCode))
      return (
        <>
          <CrossIcon className={styles.icon} />
          Recipient&apos;s preference can&apos;t be applied
          <Infotip>
            <p>
              We can&apos;t leave this parcel in the recipient&apos;s preferred location, because the sender requires a
              signature on delivery.
            </p>
          </Infotip>
        </>
      );
  }
};

export default recipientLine;
